import { ui } from "@/components/ui";

const DiarySkeleton = () => {
	return (
		<div className="space-y-4 w-full h-full">
			<div className="flex flex-row flex-wrap-reverse justify-between gap-2 my-2">
				<div className="flex justify-between md:justify-center items-center gap-x-2 md:w-fit">
					<ui.Skeleton className="w-full h-10" />
				</div>
				<div className="flex justify-between md:justify-center items-center gap-x-2 w-full md:w-fit">
					<ui.Skeleton className="w-32 h-10" />
					<ui.Skeleton className="rounded-full w-10 h-10" />
				</div>
			</div>
			<ui.Skeleton className="w-full h-[calc(100vh-200px)]" />
		</div>
	);
};

export default DiarySkeleton;
